import React from 'react';
import Layout from "../components/layouts";
import { Helmet } from 'react-helmet';
import cta1 from "../images/carpoolchella-cta-1.jpg";
import cta2 from "../images/carpoolchella-cta-2.jpg";
import cta3 from "../images/carpoolchella-cta-3.jpg";
import cta4 from "../images/carpoolchella-cta-4.jpg";
import cta5 from "../images/carpoolchella-cta-5.jpg";
import scaqmdLogo from "../images/SCAQMD.png";

// One image in intro; four in gallery (cta6 removed — duplicate of header)
const carpoolCtaGallery = [cta2, cta3, cta4, cta5];

const CarpoolchellaCallToArtists = () => {
  return (
    <Layout navBg>
      <Helmet>
        <title>Carpoolchella Call to Artists | Global Inheritance</title>
        <meta name="description" content="Design the Carpoolchella bumper sticker for Coachella 2026. Submit by March 28, 2026 for a chance to win VIP passes, camping, and more." />
      </Helmet>
      <div className="carpoolchella-call-page">
        <section className="carpoolchella-call-container">
          <div className="carpoolchella-call-intro">
            <div className="carpoolchella-call-text-block">
              <div className="carpoolchella-call-artist-call">
                <p>Attention all artists: We need your help spotting carpoolers as they arrive at Coachella 2026. Design an epic Carpoolchella bumper sticker, and if your artwork is picked, you'll roll to the festival with (2) VIP passes, camping, and other cool prizes.</p>
                <p>Carpoolchella is one of the festival's longest-running programs — awarding prizes of all sizes, including VIP for Life, since 2007. Every year, winners are selected at random by our team of secret spotters, who patrol the parking lots scanning the incoming cars with the word Carpoolchella displayed somewhere on the vehicle.</p>
                <p>Coachella + Global Inheritance are looking for the coolest Carpoolchella bumper sticker designs for people to display while carpooling to the festival. Your artwork should be created to be printable at <strong>11.5"w x 3"h</strong>. The deadline to submit concepts is <strong>March 28, 2026</strong>. Three winning bumper sticker concepts will be announced on or shortly after <strong>March 28, 2026</strong>.</p>
                <p>Artwork will be judged on creativity, originality, and distinctive use of the name Carpoolchella in the design. There are no limits on the number of submissions. AI-generated art will not be accepted.</p>
                <p>Carpooling to Coachella with 4 or more friends? Visit the <a href="https://www.coachella.com/carpoolchella" target="_blank" rel="noopener noreferrer">Carpoolchella website</a> for more details + contest rules.</p>
                <div className="carpoolchella-call-nav">
                  <a href="#form">Submit your design</a>
                </div>
              </div>
            </div>
            <div className="carpoolchella-call-intro-img">
              <img src={cta1} alt="Carpoolchella" />
            </div>
          </div>

          <div className="carpoolchella-call-body">
            <div className="carpoolchella-call-how">
              <h3>How Do I Enter?</h3>
              <p>Simply fill out the application form below and submit your design by March 28, 2026.</p>
              <h3>Prizes</h3>
              <ul>
                <li><span className="carpoolchella-call-emoji" aria-hidden>🏆</span> <strong>3 finalists</strong> will each win 2 Coachella VIP passes, camping, and merch</li>
                <li><span className="carpoolchella-call-emoji" aria-hidden>🏆</span> <strong>5 runners-up</strong> will each win a 2026 Coachella hoodie + hat</li>
              </ul>
              <p>Good luck and happy carpooling!</p>
              <p>Questions? <a href="mailto:pb@globalinheritance.org">pb@globalinheritance.org</a>.</p>
              <p>
                Read the{' '}
                <a href="/carpoolchella-contest-rules" target="_blank" rel="noopener noreferrer">
                  official contest rules
                </a>
                .
              </p>
              <p className="carpoolchella-call-clean-air">
                <img
                  src={scaqmdLogo}
                  alt="South Coast AQMD"
                  className="carpoolchella-call-scaqmd-logo"
                />
                <span>
                  Clean air matters! Global Inheritance is partnering with our friends South Coast AQMD this Earth Month to
                  promote sustainable transportation!{' '}
                </span>
              </p>
            </div>
          </div>

          <div className="carpoolchella-call-gallery">
            {carpoolCtaGallery.map((src, i) => (
              <div key={i} className="carpoolchella-call-gallery-tile">
                <img src={src} alt={`Carpoolchella ${i + 1}`} />
              </div>
            ))}
          </div>

          <div id="form" className="carpoolchella-call-form-wrap">
            <iframe
              className="carpoolchella-call-airtable"
              title="Carpoolchella design submission"
              src="https://airtable.com/embed/appbKAdb2AoFy0IjM/pagJCDdr41ZI67Ffo/form"
              frameBorder="0"
              width="100%"
              height="533"
            />
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default CarpoolchellaCallToArtists;
